<script lang="ts" setup>
import { onMounted } from 'vue';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';
import useDashboardContext from '@Use/useDashboardContext';
import { DetailsLayout, ShowcaseLayout, IllustrationDocumentSignature } from '@Shared';
import ShowcaseImage from '@Components/ShowcaseImage.vue';
import EsignatureCompleteContent from '@Components/EsignatureCompleteContent.vue';
import { finalizeSigningApi } from '@Api/esignature.api';
import { consumeSigningCompleteObserved } from '@Services/signingCompletionGate';

const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const { isDashboardContext, isLoadingContext } = useDashboardContext();
onMounted(() => {
    if (consumeSigningCompleteObserved()) {
        void finalizeSigningApi();
    }
});
</script>

<template>
    <app-page-loader v-if="isLoadingContext" />

    <details-layout
        v-else-if="isDashboardContext"
        title="Your document has been submitted"
        illustration-align="bottom"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl">
        <template #illustration>
            <illustration-document-signature />
        </template>

        <esignature-complete-content :show-title="false" />
    </details-layout>

    <showcase-layout
        v-else
        title="Your document has been submitted"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        show-powered-by>
        <template #mobileAccent>
            <div class="esignature-complete-candy">
                <img
                    class="esignature-complete-candy__image"
                    :src="'/images/esignature/secure-signing.svg'"
                    alt="" />
            </div>
        </template>

        <template #branded>
            <showcase-image />
        </template>

        <esignature-complete-content :show-title="false" />
    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.esignature-complete-candy {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__image {
        max-width: 11.6875rem;
        max-height: 11rem;

        @include desktop {
            width: 25rem;
            max-width: none;
            max-height: 21.6875rem;
        }
    }
}
</style>
